import { configureStore as configureStoreFunc } from './configureStore';

export { store } from './store';
export { configureStore } from './configureStore';
export { useAppDispatch, useAppSelector } from './hooks';
export { domainRegistry } from './domainRegistry';
export type { RootState, AppDispatch, AppStore } from './store';
export type { DomainConfig, StoreConfig } from './types';

// Export slices
export * from './slices';

// Default export для сумісності
export default configureStoreFunc;
